import React from "react";
import { Table, Input, Descriptions, Button } from "antd";
import { lang, MODE_SCREEN, STYLE } from "../../constants/common.const";
import { DeleteFilled, DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { Row, Col } from "antd";

const EquipmentContentCanEditLabel = ({
  mode = MODE_SCREEN.VIEW,
  data = [],
  handleAddRow,
  handleDeleteRow,
  handleChangeValueRow,
  setData = () => {},
  clickSave,
  setIsDirty
}) => {
  const renderDataView = (list) => {
    return (
      <Descriptions className="customEquipmentDes" size="small" column={2} bordered>
        {list.map((item, index) => (
          <Descriptions.Item
            labelStyle={{
              width: "20%",
              fontWeight: "bold",
            }}
            contentStyle={{ padding: "4px 4px" }}
            key={index}
            span={2}
            label={
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <span style={{ fontWeight: "bold" }}>{item.title.value}</span>
              </div>
            }
          >
            {item.content.value}
          </Descriptions.Item>
        ))}
      </Descriptions>
    );
  };

  const renderInput = (list) => {
    return list.map((item, index) => (
      <Row
        key={index}
        align="middle"
        gutter={8}
        style={{
          marginBottom: 8,
        }}
      >
        <Col className="mr10" style={{ width: 36 }}>
          <Button
            onClick={() => {
              setIsDirty(true)
              handleDeleteRow(data, setData, item.key);
            }}
            icon={
              <DeleteOutlined
                style={{
                  color: "red",
                }}
              />
            }
            size="small"
            style={{
              width: 32,
              height: 32,
              minWidth: 32,
              borderRadius: 4,
            }}
          />
        </Col>
        <Col flex={1}>
          <Input
            className={
              String(item.title.value).trim() === "" &&
              String(item.content.value).trim() &&
              clickSave
                ? STYLE.BORDER_RED
                : ""
            }
            onChange={(e) => {
              setIsDirty(true)
              handleChangeValueRow(
                data,
                setData,
                item.key,
                "title",
                e.target.value
              );
            }}
            value={item.title.value}
          />
        </Col>
        <Col flex={2}>
          <Input
            className={
              String(item.title.value).trim() &&
              String(item.content.value).trim() === "" &&
              clickSave
                ? STYLE.BORDER_RED
                : ""
            }
            onChange={(e) => {
              setIsDirty(true)
              handleChangeValueRow(
                data,
                setData,
                item.key,
                "content",
                e.target.value
              );
            }}
            value={item.content.value}
          />
        </Col>
      </Row>
    ));
  };

  return (
    <div  style={{
      overflowX:"hidden"
    }}>
      {mode === MODE_SCREEN.VIEW ? renderDataView(data) : renderInput(data)}
      {mode !== MODE_SCREEN.VIEW && (
        <div className={data.length > 0 ? "mt15" : ""}>
          <Button
            className="buttonPC button--info"
            onClick={() => {
              handleAddRow(data, setData);
            }}
          >
            <PlusOutlined /> {lang.ADD}
          </Button>
        </div>
      )}
    </div>
  );
};

export default EquipmentContentCanEditLabel;
